// src/components/home/HomeFinalCTA.jsx

import React from "react";
import { Link } from "react-router-dom";

import "./css/HomeFinalCTA.css";

const HomeFinalCTA = () => {
  return (
    <section className="home-final-cta">

      <div className="home-final-cta-decoration">
        आयुर्वेद
      </div>


      <div className="home-final-cta-content">

        <span className="home-section-eyebrow">
          YOUR WELLNESS JOURNEY
        </span>

        <h2>
          Begin your journey
          <br />
          towards better health.
        </h2>

        <p>
          Discover a personalized approach to wellness rooted
          in the principles of Ayurveda.
        </p>

        <Link
          to="/contact"
          className="home-button home-button-light"
        >
          Book an Appointment
        </Link>

      </div>

    </section>
  );
};

export default HomeFinalCTA;